import config from 'config/api';
import isArray from 'mout/lang/isArray';

export default ($$card) => {
  let cardImage = false;
  // let cardPresentation = false;
  const col="mediaThumb";
  let decodedValues;
  if (
    $$card !== false &&
    $$card !== undefined &&
    $$card.get(col) !== undefined &&
    $$card.get(col) !== null &&
    $$card.get(col) !== false
  ) {
    try {
      decodedValues = JSON.parse($$card.get(col));
    } catch (e) {}
    // console.log('decoded is', decodedValues)
    if (decodedValues !== undefined && isArray(decodedValues) && decodedValues[0] && decodedValues[0].dest) {
      cardImage =
        config.mediathumbpreview.replace('{id}', $$card.get('id')) + '/' + decodedValues[0].dest;
    }
  }
  return cardImage;
};
